import { render, staticRenderFns } from "./xiaoshouQuyuGuanxikongzhi.vue?vue&type=template&id=84c311a8"
import script from "./xiaoshouQuyuGuanxikongzhi.vue?vue&type=script&lang=js"
export * from "./xiaoshouQuyuGuanxikongzhi.vue?vue&type=script&lang=js"
import style0 from "./xiaoshouQuyuGuanxikongzhi.vue?vue&type=style&index=0&id=84c311a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports